module.exports = __webpack_public_path__ + "static/media/star-half-alt.4e7de533.svg";